import CryptoJS from "crypto-js";

const SECRET_KEY = "mi_clave_super_secreta";

export function encryptId(id) {
	if (!id) return "";
	const encrypted = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
	return encodeURIComponent(encrypted);
}

export function decryptId(encryptedId) {
	try {
		const decoded = decodeURIComponent(encryptedId);
		const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
		return bytes.toString(CryptoJS.enc.Utf8);
	} catch (error) {
		console.error("Error al desencriptar el ID:", error);
		return null;
	}
}
